/**
 * @file 公共响应定义
 * @author luyinpeng
 * @date 2026-03-25
 * @description定义 API 公共响应的基础接口
 */
// 定义支持的参数值类型（避免使用 any）
export type QueryValue =
    | string
    | number
    | boolean
    | null
    | undefined
    | (string | number | boolean)[];

/**
 * API 响应的基础接口
 */
export interface ApiResponse<T> {
    success: boolean;
    message: string;
    result: T;
    statusCode?: string;
}

/**
 * 代理请求配置接口
 */
export interface ProxyRequestConfig {
    method?: string;
    headersToForward?: string[];
}

/**
 * API 工厂请求选项
 */
export type ApiRequestOptions = RequestInit;

// 登录类型枚举
export enum LoginType {
    ACCOUNT = 'account',
    MOBILE = 'mobile',
    OPENID = 'openid',
}

// 来源枚举
export enum Origin {
    LOCAL = 'local',
}
